import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  theme: {
    primary: "#62637d",
    secondary: "#3f3f3f",
    accent: "#595047",

    info: "#2196F3",
    success: "#73BE20",
    warning: "#FFC107",
    error: "#c75450"
  }
});
